import React, { useRef, useState } from "react";
import { Form, Button, Card, Alert, Container } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import { firestore } from "../firebase";
import Select from 'react-select';
import {
  DropdownButton,
  Dropdown,
  Row,
  Col,
  Image,
  ButtonGroup,
  Spinner,
} from "react-bootstrap";

export default function Signup() {
  const emailRef = useRef();
  const nameRef = useRef();
  const lastNameRef = useRef();
  const phoneNumberRef = useRef();
  const occupationRef = useRef();
  const locationRef = useRef();
  const institutionRef = useRef();
  const educationRef = useRef();
  const commentsRef = useRef();
  const passwordRef = useRef();
  const ageRef = useRef();
  const passwordConfirmRef = useRef();
  const { signup, currentUser, getCurrentUser } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [experienceLarvaRef, setExperienceLarva] = useState(null);
  const [experienceLarvaID, setExperienceLarvaID] = useState(null);
  const history = useHistory();

  var nameToStore = "";
  var lastNameToStore = "";
  var phoneNumberToStore = "";
  var emailToStore = "";
  var occupationToStore = "";
  var experienceLarvaToStore = "";
  var experienceLarvaIDToStore = "";
  var ageToStore = "";
  var locationToStore = "";
  var educationToStore = "";
  var commentsToStore = "";
  var institutionToStore = "";

  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  const options = [
    { value: 'beginner', label: 'beginner' },
    { value: 'intermediate', label: 'intermediate' },
    { value: 'expert', label: 'expert' },
  ];

  function handleSubmit(e) {
    e.preventDefault();
    experienceLarvaToStore = experienceLarvaRef;
    experienceLarvaIDToStore = experienceLarvaID;
    if (experienceLarvaIDToStore === null || experienceLarvaToStore === null) {
      return setError("Experience is required!");
    }
    nameToStore = nameRef.current.value;
    lastNameToStore = lastNameRef.current.value;
    //phoneNumberToStore = phoneNumberRef.current.value;
    emailToStore = emailRef.current.value;
    occupationToStore = occupationRef.current.value;
    //ageToStore = ageRef.current.value;
    locationToStore = locationRef.current.value;
    educationToStore = educationRef.current.value;
    commentsToStore = commentsRef.current.value;
    institutionToStore = institutionRef.current.value;
    try {
      setError("");
      setLoading(true);
      firestore.collection("users").doc(emailRef.current.value).set({
        firstName: nameToStore,
        lastName: lastNameToStore,
        email: emailToStore,
        occupation: occupationToStore,
        experienceAnatomy: experienceLarvaToStore,
        experienceID: experienceLarvaIDToStore,
        //age: ageToStore,
        location: locationToStore,
        education: educationToStore,
        comments: commentsToStore,
        //phoneNumber: phoneNumberToStore,
        institution: institutionToStore
      }).then(() =>{
        history.push("/registered");
      })
    } catch (e) {
      console.log(e);
      setError("Failed to create an account😞");
    }
    setLoading(false);
  }

  return (
    <>
      <Container
        className="align-items-center justify-content-center"
        style={{ minHeight: "100vh" }}
      >
        <br />
        <br />
        <br />
        <br />
        <p className="text-center mb-4"><b>Thank you for contributing to our larva identification project!</b></p>
        <Card>
          <Card.Body>
            <p className="text-center mb-4"><b>Please enter your information below</b></p>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group id="firstname">
                <Form.Label>First Name</Form.Label>
                <Form.Control ref={nameRef} required />
              </Form.Group>
              <Form.Group id="lastname">
                <Form.Label>Last Name</Form.Label>
                <Form.Control ref={lastNameRef} required />
              </Form.Group>
              <Form.Group id="email">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" ref={emailRef} required />
              </Form.Group>
              <Form.Group id="education">
                <Form.Label>Education</Form.Label>
                <Form.Control ref={educationRef} required />
              </Form.Group>
              <Form.Group id="occupation">
                <Form.Label>Occupation</Form.Label>
                <Form.Control ref={occupationRef} required />
              </Form.Group>
              <Form.Group id="institution">
                <Form.Label>Institution</Form.Label>
                <Form.Control ref={institutionRef} required />
              </Form.Group>
             {/* <Form.Group id="phone">
                <Form.Label>Phone Number (Optional)</Form.Label>
                <Form.Control ref={phoneNumberRef} />
              </Form.Group>*/}
            {/* <Form.Group id="age">
                <Form.Label>Age</Form.Label>
                <Form.Control ref={ageRef} required />
              </Form.Group> */ }
              <Form.Group id="location">
                <Form.Label>City / State / Country</Form.Label>
                <Form.Control ref={locationRef} required />
              </Form.Group>
              <Form.Group id="experienceLarva">
                <Form.Label>Experience: Mosquito Larva Anatomy</Form.Label>
                <DropdownButton
              variant="secondary"
              title={!!experienceLarvaRef ? experienceLarvaRef : "Select:"}
              onSelect={(e) => {
                setExperienceLarva(e);
              }}
              required
            >
              <Dropdown.Item as="button" eventKey="Beginner" onClick={(e) => {
                e.preventDefault();
              }}>
                Beginner
              </Dropdown.Item>
              <Dropdown.Item as="button" eventKey="Intermediate" onClick={(e) => {
                e.preventDefault();
              }}>
                Intermediate
              </Dropdown.Item>
              <Dropdown.Item as="button" eventKey="Expert" onClick={(e) => {
                e.preventDefault();
              }}>
                Expert
              </Dropdown.Item>
              </DropdownButton>
              </Form.Group>
              <Form.Group id="experienceLarvaID">
                <Form.Label>Experience: Mosquito Larva Identification (to genus or species)</Form.Label>
                <DropdownButton
              variant="secondary"
              title={!!experienceLarvaID ? experienceLarvaID : "Select:"}
              onSelect={(e) => {
                setExperienceLarvaID(e);
              }}
              required
            >
              <Dropdown.Item as="button" eventKey="Beginner" onClick={(e) => {
                e.preventDefault();
              }}>
                Beginner
              </Dropdown.Item>
              <Dropdown.Item as="button" eventKey="Intermediate" onClick={(e) => {
                e.preventDefault();
              }}>
                Intermediate
              </Dropdown.Item>
              <Dropdown.Item as="button" eventKey="Expert" onClick={(e) => {
                e.preventDefault();
              }}>
                Expert
              </Dropdown.Item>
              </DropdownButton>
              </Form.Group>
              <Form.Group id="comments">
                <Form.Label>Comments or Specific Interests (Optional)</Form.Label>
                <Form.Control ref={commentsRef} />
              </Form.Group>
              {error && <Alert variant="danger">{error}</Alert>}
              <Button disabled={loading} className="w-100" type="submit">
                Register
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
